import React from "react";
type SectionHeadingProps = {
  label?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  invert?: boolean;
};
export function SectionHeading({
  label,
  title,
  lead,
  invert = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-60" data-mp="3f2n6bvub0opy">
      {label && <p className={`text-xs font-bold uppercase tracking-[0.14em] sm:text-sm ${invert ? "text-brand-200" : "text-brand-600"}`} data-id="element-61" data-mp="3jzdmska0tmbw">
          {label}
        </p>}
      <h2 className={`mt-2 font-serif text-[1.85rem] font-extrabold leading-[1.12] sm:text-4xl lg:text-5xl ${invert ? "text-white" : "text-ink"}`} data-id="element-62" data-mp="gjgkexi3pio4">
        {title}
      </h2>
      {lead && <p className={`mx-auto mt-4 max-w-2xl text-base leading-relaxed sm:text-lg ${invert ? "text-brand-100" : "text-muted"}`} data-id="element-63" data-mp="6svesq40fdvp">
          {lead}
        </p>}
    </div>;
}